let presentsWereChanged = false,
    presentsInitialized = false;

function checkPresentsCheckboxes($list) {
    const maxCount = $list.attr('data-max'),
        checkedCount = $list.find('.c-form__input:checked').length;

    if (checkedCount == maxCount) {
        $list.find('.c-form__input:not(:checked)').each(function () {
            $(this).prop('disabled', true);
            $(this).parents('.presents__item').addClass('is-disabled');
        });
    } else {
        $list.find('.c-form__input:disabled').each(function () {
            $(this).prop('disabled', false);
            $(this).parents('.presents__item').removeClass('is-disabled');
        });
    }
};

$(function() {
    $(document).on('shown.bs.modal', '#up-sell, #present-modal', function () {
        const $form = $('#presentForm');

        $('.presents__list').each(function() {
            checkPresentsCheckboxes($(this));
        });

        if ($form.length > 0 && !presentsInitialized) {
            $('body').on('change', '#presentForm .presents__list .c-form__input', function () {
                checkPresentsCheckboxes($(this).parents('.presents__list'));

                presentsWereChanged = true;
            });

            $('body').on('click', '#up-sell .c-btn--cart', function (event) {
                if (presentsWereChanged) {
                    const url = $(this).attr('href');

                    event.preventDefault();

                    showPreloader();

                    Form.ajaxPost($form, function (data) {
                        window.location = url;
                    }, "json");
                }
            });

            $('body').on('click', '#present-modal .c-btn--cart', function (event) {
                event.preventDefault();

                if (presentsWereChanged) {
                    const url = $(this).attr('href');

                    showPreloader();

                    Form.ajaxPost($form, function (data) {
                        window.location = url;
                    }, "json");
                } else {
                    $('#present-modal').modal('hide');
                }
            });

            presentsInitialized = true;
        }
    })

    $(document).on('hide.bs.modal', '#up-sell', function () {
        if (presentsWereChanged) {
            const $form = $('#presentForm');

            presentsWereChanged = false;

            Form.ajaxPost($form, function (data) { }, "json");
        }
    })
});
